import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from  '../components/Login.vue'
import newLogin from  '../components/newLogin.vue'
import splesh from "@/views/Splesh.vue";
import productsView from "@/views/ProductView.vue";
import productsShow from "@/views/ProductShow.vue";
import Category from "@/views/CategoryView.vue";
import ProfileView from "@/views/profileView.vue";
import Profile from "@/views/profile.vue";
import Cartview from "@/views/Cartview.vue";
import NewCartview from "@/views/newCart.vue";
import logout from "@/components/Logout.vue";
import NewHome from "@/views/NewHome.vue";
import profileView from "@/views/profileView.vue";
import CheckoutView from "@/views/CheckoutView.vue";
import BestSeller from "@/components/BestSeller.vue";
import Heart from "@/components/Heart.vue";
import Orders from "@/components/Orders.vue";


const routes = [
  {
    path: '/',
    name: 'splesh',
    component: splesh
  },
  {
    path: '/login',
    name: 'newlogin',
    component: newLogin
  },
  {
    path: '/logout',
    name: 'logout',
    component: logout
  },
  {
    path: '/home',
    name: 'home',
    component: NewHome
  },
  {
    path: '/category',
    name: 'category',
    component: Category
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/cart',
    name: 'cart',
    component: NewCartview
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: CheckoutView
  },
  {
    path: '/callback',
    name: 'callback',
    component: CheckoutView
  },
  {
    path: '/bestseller',
    name: 'bestseller',
    component: BestSeller
  },
  {
    path: '/orders',
    name: 'orders',
    component: Orders
  },
  {
    path: '/heart',
    name: 'heart',
    component: Heart
  },
  {
    path: `/products/:id/:name`,
    name: 'products-view',
    component: productsView
  },
  {
    path: `/product/:id/`,
    name: 'product-show',
    component: productsShow
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
